var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineBuilding3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 22.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h20c.41 0 .75.34.75.75s-.34.75-.75.75H2z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.48 22.54a.75.75 0 0 1-.22-.53L2.25 7.07c0-.91.46-1.77 1.22-2.28l4-2.67c.93-.62 2.13-.62 3.05 0l4 2.67c.77.51 1.22 1.36 1.22 2.28l.01 14.92c0 .41-.33.75-.75.75l-11.99.02a.75.75 0 0 1-.53-.22zM8.31 3.36l-4 2.67c-.35.23-.56.62-.56 1.04l.01 14.19 10.5-.02-.01-14.17c0-.42-.21-.81-.55-1.03l-4-2.67c-.21-.15-.46-.22-.7-.22-.24 0-.48.07-.69.21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.23 22.01V18c0-.41.34-.75.75-.75s.75.34.75.75v4.01a.749.749 0 1 1-1.5 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 16v-2c0-1.52 1.23-2.75 2.75-2.75s2.75 1.23 2.75 2.75v2c0 1.52-1.23 2.75-2.75 2.75s-2.75-1.23-2.75-2.75zm1.5-2v2a1.25 1.25 0 0 0 2.5 0v-2a1.25 1.25 0 0 0-2.5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 14.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h12c.41 0 .75.34.75.75s-.34.75-.75.75H3zM8.25 22v-3.75c0-.41.34-.75.75-.75s.75.34.75.75V22c0 .41-.34.75-.75.75s-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 9c0-1.24 1.01-2.25 2.25-2.25S11.25 7.76 11.25 9 10.24 11.25 9 11.25 6.75 10.24 6.75 9zm1.5 0c0 .41.34.75.75.75s.75-.34.75-.75-.34-.75-.75-.75-.75.34-.75.75z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineBuilding3);
export default __webpack_public_path__ + "static/media/vuesax-outline-building-3.a0e42807fdcafbbdc8e2295bf434618a.svg";
export { ForwardRef as ReactComponent };